import { useLocation } from "react-router-dom";
import { useEffect} from "react";
import "./index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUserTie,
  faBriefcase,
  faBookOpen,
  faAddressCard,
  faInfoCircle
} from "@fortawesome/free-solid-svg-icons";

export default function TOC() {
  const { pathname } = useLocation();

  const links_nav = [
    { label: "home", path: "#/home", textlab: "Home", icon: faHome },
    { label: "blog", path: "#/blog", textlab: "Blog", icon: faBookOpen },
    { label: "industry", path: "#/industry", textlab: "Experience", icon: faUserTie },
    { label: "portfolio", path: "#/portfolio", textlab: "Portfolio", icon: faBriefcase },
    { label: "about", path: "#/about", textlab: "About", icon: faInfoCircle },
    { label: "contact", path: "#/contact", textlab: "Contact", icon: faAddressCard },
  ];

  useEffect(() => {
    // Collapse the navbar manually on route change
    const navCollapse = document.getElementById("navbarSupportedContent");
    if (navCollapse && navCollapse.classList.contains("show")) {
      navCollapse.classList.remove("show");
    }

    const toggleBtn = document.querySelector('[data-bs-target="#navbarSupportedContent"]');
    if (toggleBtn && toggleBtn.getAttribute("aria-expanded") === "true") {
      toggleBtn.setAttribute("aria-expanded", "false");
    }
  }, [pathname]);

  

  return (
    <div id="wd-navigation-webpage">
      <nav className="navbar navbar-dark navbar-expand-lg fixed-top bg-dark" style={{ color: "#015d82" }} >
        <div className="container-fluid align-self-center">
          <a className="navbar-brand" href="#/home/">Alfonso Barajas Cervantes</a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              {links_nav.map((link_nav, idx) => (
                <li className="nav-item" key={idx}>
                  <a
                    className={`nav-link ${pathname.includes(link_nav.label) ? "active" : ""}`}
                    href={link_nav.path}
                  >
                    <FontAwesomeIcon icon={link_nav.icon} className="small" /> {link_nav.textlab}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}
